import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { DealsPage } from "@/features/deals/DealsPage";

const search = z.object({
  view: z.enum(["list", "table", "board"]).optional(),
  peek: z.string().optional(),
  pipeline: z.string().optional(),
});

export const Route = createFileRoute("/_app/deals/")({
  validateSearch: search,
  component: () => <DealsPage search={Route.useSearch()} />,
});
